import { PrivacyVisibility } from "iasma-datatypes";
import { Check, ChevronDown, ChevronUp, Eye, Lock, Plus, PlusCircle, Users } from "lucide-react";
import { ReactNode, useEffect, useRef, useState } from "react";

interface PrivacySelectorProps {
	visibility: PrivacyVisibility;
	isEditing: boolean;
	onChange: (visiblility: PrivacyVisibility) => void;
}

interface OptionItem {	
	value: PrivacyVisibility;
	label: string;
	icon: any;
	color: string;
	info: string;
}

const options : OptionItem[] = [
	{ value: PrivacyVisibility.Public, label: 'Alumni', icon: Eye, color: "bg-linear-to-br from-green-500 to-green-600", info: "terlihat seluruh alumni terdaftar" },
	{ value: PrivacyVisibility.Angkatan, label: 'Angkatan', icon: Users, color: "bg-linear-to-br from-blue-300 to-blue-400", info: "terlihat sesama angkatan" },
	{ value: PrivacyVisibility.Admin, label: 'Admin', icon: Lock, color: "bg-linear-to-br from-orange-500 to-orange-600", info: "terlihat pengurus yang berwenang" },
];

export const PrivacySelector: React.FC<PrivacySelectorProps> = ({ visibility, isEditing, onChange }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selected, setSelected] = useState<OptionItem>(options[0]);
	const dropdownRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	useEffect(() => {
		let option = options.filter( opt => opt.value === visibility);
		setSelected(option[0])
	}, [visibility]);

	const handleSelect = (option: OptionItem) => {
		setSelected(option);
		if (onChange) {
			onChange(option.value)
		}
		setIsOpen(false);
	};

	const SelectedIcon = selected.icon;

	return (
		<div className="flex items-center justify-center">
			<div className="w-full max-w-xs">
				<div className="relative" ref={dropdownRef}>
					<button
						onClick={() => setIsOpen(!isOpen)}
						className="w-8 h-8 rounded-lg flex items-center justify-center  transition-all duration-200 relative"
					>
						<div className={`w-7 h-7  rounded-md flex ${selected.color} items-center justify-center`}>
							<SelectedIcon className="w-4 h-4 text-white" />
						</div>
					</button>

					{isOpen && (
						<div className="absolute right-0 top-0 mt-8 w-48 bg-white border-2 border-slate-200 rounded-lg shadow-lg overflow-hidden z-10 animate-in fade-in slide-in-from-top-2 duration-200">
							{options.map((option) => {
								const OptionIcon = option.icon;
								const isSelected = selected.value === option.value;

								return (
									<button
										key={option.value}
										onClick={() => handleSelect(option)}
										className={`w-full px-2 gap-0.5 py-1 flex flex-col items-start transition-colors duration-150 ${isSelected ? 'bg-blue-50' : ''}`}
									>
										<div className={`flex flex-row items-center justify-between gap-2 ${isSelected ? 'text-blue-600' : 'text-slate-700'}`}>
											<div className={`w-7 h-7 rounded-md flex items-center justify-center ${option.color}`}>
												<OptionIcon className={`w-4 h-4 text-white`} />
											</div>
											<span className="text-sm font-medium text-left">
												{option.label}
											</span>
											{isSelected && (
												<Check className="w-4 h-4 text-blue-600" />
											)}
										</div>
										<span className="text-xs font-light text-left">
											{option.info}
										</span>
									</button>
								);
							})}
						</div>
					)}
				</div>

			</div>
		</div>
	);
};
